import React from "react";

const SkeletonLoader = () => {
  return (
    <div className="Loader-details flex flex-wrap gap-4 justify-between lg:px-[12%]  md:px-[10%] px-[2%] h-[100vh] bg-white animate-pulse rounded-md  pt-10">
      <div className="imageSection flex flex-col w-ful h-[375px] gap-6 ">
        <div className="MainImage lg:w-[420px] md:w-[420px] w-[390px] h-[300px] bg-gray-600 animate-pulse rounded-t-md  "></div>
        <div className="SlideImage flex gap-4">
          <div className="slide1 w-[67px] h-[60px] bg-gray-400 animate-pulse rounded "></div>
          <div className="slide2  w-[67px] h-[60px] bg-gray-400 animate-pulse rounded "></div>
          <div className="slide3 w-[67px] h-[60px] bg-gray-400 animate-pulse rounded"></div>
          <div className="slide4 w-[67px] h-[60px] bg-gray-400 animate-pulse rounded"></div>
          <div className="slide5 w-[67px] h-[60px] bg-gray-400 animate-pulse rounded"></div>
        </div>
      </div>
      <div className="detailSection lg:w-[40%]  flex flex-col gap-[5px]">
        <div className="w-[240px] h-[15px] bg-gray-200 animate-pulse rounded mb-2"></div>
        <div className="w-[340px] h-[15px] bg-gray-200 animate-pulse rounded mb-2"></div>
        <div className="w-[240px] h-[15px] bg-gray-200 animate-pulse rounded mb-2"></div>
        <div className="w-[350px] h-[15px] bg-gray-200 animate-pulse rounded mb-2"></div>
        <div className="w-[400px] h-[15px] bg-gray-200 animate-pulse rounded mb-2"></div>
        <div className="w-[240px] h-[15px] bg-gray-200 animate-pulse rounded mb-2"></div>
        <div className="w-[200px] h-[15px] bg-gray-200 animate-pulse rounded mb-2"></div>
        <div className="w-[540px] h-[15px] bg-gray-200 animate-pulse rounded mb-2"></div>
        <div className="w-[550px] h-[15px] bg-gray-200 animate-pulse rounded mb-2"></div>
        <div className="w-[260px] h-[15px] bg-gray-200 animate-pulse rounded mb-2"></div>
        <div className="w-[280px] h-[15px] bg-gray-200 animate-pulse rounded mb-2"></div>
        <div className="w-[200px] h-[15px] bg-gray-200 animate-pulse rounded mb-2"></div>
        <div className="w-[210px] h-[15px] bg-gray-200 animate-pulse rounded mb-2"></div>
        <div className="w-[300px] h-[15px] bg-gray-200 animate-pulse rounded mb-2"></div>
        <div className="w-[280px] h-[15px] bg-gray-200 animate-pulse rounded mb-2"></div>
        <div className="w-[240px] h-[15px] bg-gray-200 animate-pulse rounded mb-2"></div>
        <div className="w-[280px] h-[15px] bg-gray-200 animate-pulse rounded mb-2"></div>
        <div className="w-[180px] h-[15px] bg-gray-200 animate-pulse rounded mb-2"></div>
      </div>
    </div>
  );
};

export default SkeletonLoader;
